<template>
    <div class="modal fade" ref="videoModal" tabindex="-1" role="dialog" aria-labelledby="video1" aria-hidden="true" data-backdrop="static" data-keyboard="false">
        <div class="modal-dialog modal-dialog-centered" role="document">
            <div class="modal-content">
                <div class="modal-body">
                    <a type="button" class="modal-close-btn" data-dismiss="modal"><img src="/images/global/close-icon.svg"></a>
                    <div class="modal-heading">
                        <template v-if="hasSlot('header')">
                            <slot name="header"></slot>
                        </template>
                        <template v-else>
                            {{ header }}
                        </template>
                    </div>
                    <div class="modal-video-area">
                        <div class="embed-responsive embed-responsive-16by9">
                            <video :id="videoId" ref="video" controls @play="started" @ended="ended">
                                <source :src="src" ref="source" type="video/mp4">
                                Sorry, your browser doesn't support embedded videos.
                            </video>
                        </div>
                    </div>
                    <div class="modal-video-desc">
                        <template v-if="hasSlot('description')">
                            <slot name="description"></slot>
                        </template>
                        <template v-else>
                            {{ description }}
                        </template>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import eventBus from '@/event-bus';

export default {
    props: {
        autoClose: {
            type: Boolean,
            default: true
        },
        disableFastForward: {
            type: Boolean,
            default: false
        },
        videoId: {
            type: String
        },
        videoSrc: {
            type: String,
            default: ''
        }
    },
    data() {
        return {
            supposedCurrentTime: 0,
            header: '',
            description: '',
            played: false,
            src: this.videoSrc ? this.videoSrc : '',
            id: this.videoId ? this.videoId : ''
        }
    },
    mounted() {
        if (this.disableFastForward) {
            this.$refs.video.addEventListener('timeupdate', this.timeUpdate);
            this.$refs.video.addEventListener('seeking', this.seeking);
        }

        eventBus.$on('videoModalOpened', this.openModal);

        $(this.$refs.videoModal).on('hide.bs.modal', () => {
            this.supposedCurrentTime = 0;
            this.$refs.video.currentTime = 0;
            this.$refs.video.pause();
        });
    },
    methods: {
        openModal($event) {
            this.header = $event.title;
            this.description = $event.description;
            this.src = $event.src;
            this.id = $event.id;

            this.$refs.video.load();

            $(this.$refs.videoModal).modal('show');
        },
        hasSlot (name = 'default') {
            return !!this.$slots[name] || !!this.$scopedSlots[name];
        },
        timeUpdate($event) {
            $event.preventDefault();

            if (!$event.currentTarget.seeking) {
                this.supposedCurrentTime = $event.currentTarget.currentTime;
            }

            return false;
        },
        seeking($event) {
            $event.preventDefault();
            const delta = $event.currentTarget.currentTime - this.supposedCurrentTime;

            if (delta > 0.01) {
                $event.currentTarget.currentTime = this.supposedCurrentTime;
            }

            return false;
        },
        started($event) {
            if (!this.played) {
                eventBus.$emit('videoStarted', {
                    modalId: this.$refs.videoModal.id,
                    videoId: this.videoId
                });

                this.played = true;
            }
        },
        ended($event) {
            this.supposedCurrentTime = 0;
            $event.currentTarget.currentTime = 0;

            eventBus.$emit('videoEnded', {
                modalId: this.$refs.videoModal.id,
                videoId: this.id
            });

            if (this.autoClose) {
                $(this.$refs.videoModal).modal('hide');
            }
        }
    },
    computed: {
        videoPlayerId() {
            return this.videoId || this.id;
        }
    }
}
</script>
